import ContentSection from './ContentSection';
export default ContentSection;



// WEBPACK FOOTER //
// ./resources/assets/js/components/ContentSection/index.js